import { ButtonProps } from "@/components/buttons/button";
import ButtonLockDependent from "@/components/buttons/button-lock-dependent";
import useProjectEditAccess from "@/services/context/project-process/use-project-edit-access";
import useProjectProcessContext from "@/services/context/project-process/use-project-process-context";

const ProjectEditButton = ({ disabled, onClick, ...props }: ButtonProps) => {
    const { isBlockedByProcess, reason } = useProjectEditAccess();
    const { isProcessBlockingEdits } = useProjectProcessContext();

    return (
        <ButtonLockDependent
            {...props}
            title={isBlockedByProcess ? reason : props.title}
            disabled={disabled || isBlockedByProcess}
            onClick={event => {
                if (!isProcessBlockingEdits()) {
                    onClick?.(event);
                }
            }}
        />
    );
};

export default ProjectEditButton;
